import React, { useEffect } from 'react';
import { alertRef } from '../../../../App';
import { Button, Input } from '../../../../Components/StyledComponents';
import './PriceFee.scss';
import {cloneDeep} from 'lodash-es';

const ExtraFee = ({DeliveryExtraFee,patchExtraFee}) => {
    const [ list, setLsit ] = React.useState([]);//배달팁 거리 할증 목록

    useEffect(() => {
        if( typeof DeliveryExtraFee !== 'undefined') setLsit(cloneDeep(DeliveryExtraFee))
    },[])

    //배달팁 거리 할증 수정
    const patch = () => {
        let arr = [];
        for( let i=0; i < list.length; i++){
            arr.push({ Distance : parseInt(list[i].Distance), ExtraFee : parseInt(list[i].ExtraFee) })
        }

        patchExtraFee(arr)
    }

    //배달팁 거리 할증 array 추가
    const addList = () => {
        if(list.length > 0 ){
            if( list[list.length - 1].Distance === null || list[list.length - 1].Distance.length === 0 || list[list.length - 1].ExtraFee === null || list[list.length - 1].ExtraFee.length ===  0 ){
                alertRef.current.showAlert({ title : '이전 항목을 입력해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
                return;
            }else if( list.length > 1 ){
                if( Number(list[list.length - 1].Distance) < Number(list[list.length - 2].Distance) || Number(list[list.length - 1].ExtraFee) < Number(list[list.length - 2].ExtraFee) ){
                    alertRef.current.showAlert({ title : '거리 또는 배달팁을 확인해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
                    return;
                }
            }
        }

        let arr = list;
        arr.push({Distance : 0, ExtraFee : 0 })
        setLsit([...arr])
    }

    //배달팁 거리 할증 array 삭제
    const removeList = (i) => {
        let arr = list;
        arr.splice(i,1);
        setLsit([...arr])
    }

    //배달팁 거리 할증 array[Index]의 Distance handler
    const handleListDistance = (val,i) => {
        let arr = list;
        list[i].Distance = val;
        setLsit([...arr])
    }

    //배달팁 거리 할증 array[Index]의 ExtraFee handler
    const handleListExtraFee = (val,i) => {
        let arr = list;
        list[i].ExtraFee = val;
        setLsit([...arr])
    }

    return (
        <div className='price-fee'>
            <p className='label' style={{ marginBottom : 8 }}>거리별 추가 할증 배달팁</p>

            {
                list.length > 0 &&
                <div style={{ marginBottom : 16 }}>
                    <p className='warn-text'>* 거리 순서대로 추가해주세요.</p>
                    <p className='warn-text'>* 거리에 따라 배달팁이 증가해야 합니다.</p>
                    <p className='warn-text'>* 매장에서부터의 거리 기준입니다.</p>
                </div>
            }

            {
                list.map((data,i) => {
                    return(
                        <div className='row' style={{ marginBottom : 16 }} key={i}>
                            <label data-domain="미터(M)">
                                <Input value={list[i].Distance} onChange={(e) => handleListDistance(e.target.value,i)} style={{ width : 150, marginRight : 8 }} />
                            </label>
                            <p className='input-text'>이상 거리에 대한</p>
                            <p className='input-text' style={{ marginLeft : 8 }}>배달팁</p>
                            <label data-domain="원">
                                <Input value={list[i].ExtraFee} onChange={(e) => handleListExtraFee(e.target.value,i)} style={{ width : 150, marginLeft : 8 }} />
                            </label>
                            <Button variant="sub" onClick={()=> removeList(i)} style={{ width : 24, height : 24, borderRadius : 100, boxSizing : 'border-box', padding : 0, marginLeft : 8 }}>
                                <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width : 21, height : 21, marginTop : 2 }} />
                            </Button>
                        </div>
                    )  
                })
            }

            <Button variant="sub" onClick={() => addList()} small style={{ paddingLeft : 16, paddingRight : 16 }}>
                <div className='row'>
                    <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                    추가하기
                </div>
            </Button>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default ExtraFee;